import React from "react"
import {
    Dropdown,
    Flex,
    Text
} from "@fluentui/react-northstar"
import { ISelectFormData } from "./Types"
export interface ISelectProps {
    selectForm: ISelectFormData;
    selectedMessageTypeChange: any;
    selectedCardTypeChange: any;
}

export default function Select(props:ISelectProps) {

    return (
        <Flex className="scrollableContent">
            <Flex.Item size="size.half">
                <Flex column className="formContentContainer">
                    <h3>Seleccione el tipo de mensaje</h3>

                    <Text content="Tarjeta" />
                    <Dropdown
                        items={props.selectForm.MessageTypes}
                        value={props.selectForm.selectedMessageType}
                        getA11ySelectionMessage={{ onAdd: item => props.selectedMessageTypeChange(item) }}
                    />

                    <Text content="Tipo" />
                    <Dropdown
                        items={props.selectForm.cardTypes}
                        value={props.selectForm.selectedCardType}
                        getA11ySelectionMessage={{ onAdd: item => props.selectedCardTypeChange(item) }}
                    />
                </Flex>
            </Flex.Item>
        </Flex>
    )
}
